export default "__VITE_ASSET__CT3putY___"